import React from 'react'
import styles from './Analytics.module.css'
import { PieChart, Pie, Cell, Legend, Sector, Tooltip } from "recharts";
import ChartContainer from '../../components/analytics/ChartContainer';
import CustomTooltip from '../../components/analytics/CustomTooltip';
import CustomLegend from '../../components/analytics/CustomLegend';

const ApplicationStatusChart = ({
    isLoading,
    errorMessage,
    isValueZero,
    activeIndex,
    onPieEnter,
    pieChartData,
    chartDescription }) => {

    const renderCustomShape = (props) => {
        const RADIAN = Math.PI / 180;
        const {
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            startAngle,
            endAngle,
            fill,
            payload,
            value,
        } = props;

        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);
        const ex = cx + (outerRadius + 20) * cos; // Position text outside the sector
        const ey = cy + (outerRadius + 20) * sin;
        // const ex = cx;
        // const ey = cy + outerRadius + 20;
        const textAnchor = cos >= 0 ? "start" : "end";

        return (
            <g

                className={styles['application-status-pie-chart']}>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                    stroke="none"
                />
                <text
                    x={ex}
                    y={ey}
                    textAnchor={textAnchor}
                    fontSize={14}
                    fontWeight={600}
                    fill="#000000"
                >
                    {`${payload.name}: ${value}`}
                </text>
            </g>
        );
    };

    return (
        <ChartContainer
            title="Application Status"
            chartDescription={chartDescription}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isValueZero={isValueZero}
        >
            <PieChart width={400} height={320} focusable="false">
                <Pie
                    label
                    fontSize={12}
                    title="Application Status"
                    data={pieChartData}
                    cx={200}
                    cy={120}
                    innerRadius={45}
                    outerRadius={100}
                    dataKey="value"
                    activeIndex={activeIndex}
                    onMouseEnter={onPieEnter}
                    tabIndex={-1}
                    className={styles['application-status-pie-chart']}
                >
                    {pieChartData.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={entry.color}
                        />
                    ))}
                </Pie>
                <Tooltip
                    content={
                        <CustomTooltip
                            labelFormatter={(label) => `Application Status`}
                            valueFormatter={(value) => `${value}`}
                            colorKey="fill"
                        />
                    }
                />
                <Legend
                    verticalAlign="bottom"
                    content={<CustomLegend />}
                />
            </PieChart>
        </ChartContainer>
    )
}

export default ApplicationStatusChart